import { Reducer } from 'redux'
import { IParticipantModel } from 'models/participant.model'
import { IParticipantState } from '../states/participants.state'
import * as fromActions from '../actions/participants.action'

export const initialState: IParticipantState = {
  list: [],
  inactiveParticipantsList: [],
  inactiveParticipantsTotal: 0,
  total: 0,
  perPage: 0,
  sort: [],
  participant: {} as IParticipantModel,
  download: '',
  loading: false,
  inactiveParticipantsListLoading: false,
  participantCourses: {} as any,
  listIds: [],
}

export const reducer: Reducer<IParticipantState> = (
  state: IParticipantState = initialState,
  { type, payload }
) => {
  switch (type) {
    case fromActions.PARTICIPANTS_PROFILES_LIST:
      return {
        ...state,
        loading: true,
      }
    case fromActions.PARTICIPANTS_PROFILES_LIST_SUCCESS: {
      const { data: list, total, perPage, sort } = payload
      return {
        ...state,
        list,
        total,
        perPage,
        sort,
        loading: false,
      }
    }
    case fromActions.PARTICIPANTS_INACTIVE_PROFILES_LIST:
      return {
        ...state,
        inactiveParticipantsListLoading: true,
      }
    case fromActions.PARTICIPANTS_INACTIVE_PROFILES_LIST_SUCCESS: {
      const { data, total: inactiveTotal } = payload
      return {
        ...state,
        inactiveParticipantsList: data,
        inactiveParticipantsTotal: inactiveTotal,
        inactiveParticipantsListLoading: false,
      }
    }
    case fromActions.PARTICIPANTS_PROFILES_GET: {
      return {
        ...state,
        loading: true,
      }
    }
    case fromActions.PARTICIPANTS_PROFILES_GET_SUCCESS: {
      return {
        ...state,
        participant: payload,
        loading: false,
      }
    }
    case fromActions.PARTICIPANTS_DOWNLOAD:
      return {
        ...state,
        loading: true,
      }
    case fromActions.PARTICIPANTS_DOWNLOAD_SUCCESS:
      return {
        ...state,
        download: payload,
        loading: false,
      }
    case fromActions.PARTICIPANTS_GET_COURSES:
      return {
        ...state,
        loading: true,
      }
    case fromActions.PARTICIPANTS_GET_COURSES_SUCCESS:
      return {
        ...state,
        participantCourses: payload,
        loading: false,
      }

    case fromActions.PARTICIPANTS_IDS_LIST:
      return {
        ...state,
        loading: true,
      }
    case fromActions.PARTICIPANTS_IDS_LIST_SUCCESS: {
      const { data: listIds } = payload
      return {
        ...state,
        listIds,
        loading: false,
      }
    }
    default:
      return state
  }
}
